if (!customElements.get("deployer-variant-builder")) {
  customElements.define(
    "deployer-variant-builder",
    class DeployerVariantBuilder extends HTMLElement {
      constructor() {
        super();
        this.main_product_form =
          this.closest(".product").querySelector('.product-form form[action*="/cart/add"]') ||
          document.querySelector('.product__page form[action*="/cart/add"]') ||
          document.querySelector('.product form[action*="/cart/add"]') ||
          document.querySelector('form[action*="/cart/add.js"]') ||
          document.querySelector('form[action*="/cart/add"]');
        if (this.main_product_form === null) return console.error("Deployer Variant Builder: No product form found");
        this.originalPriceHtml = null;
      }

      connectedCallback() {
        this.storeOriginalPrice();
        this.querySelectorAll(".dvb_variant").forEach((variant) => {
          if (variant.querySelector(".deployer-quantity") != null) {
            variant.querySelector("input").addEventListener("change", this.onInputQuantityChange.bind(this, variant));
            variant.querySelectorAll("button").forEach((button) => {
              button.addEventListener("click", (event) => {
                this.onButtonQuantityClick(event.target, variant);
              });
            });
          }
        });
        this.initPopularVariants();
        this.bindSubscriptionSync();
        this.updateEverything();
      }

      bindSubscriptionSync() {
        if (this.dataset.syncSubscription !== 'true' || this.subscriptionSyncBound) return;

        document.addEventListener('subscription:plan-change', () => {
          this.addSelectionToForm();
        });
        this.subscriptionSyncBound = true;
      }

      getSyncedSellingPlanId() {
        if (this.dataset.syncSubscription !== 'true') return '';

        const widget = document.querySelector('subscription-widget');
        if (!widget) return '';

        const selectedOption = widget.querySelector('.subscription-widget__option--selected');
        if (!selectedOption || !selectedOption.classList.contains('subscription-widget__option--subscription')) return '';

        const select = selectedOption.querySelector('.select__select');
        if (!select) return '';

        return select.options[select.selectedIndex]?.dataset.value || '';
      }

      initPopularVariants() {
        const popularContainer = this.querySelector(".dvb_popular-variants");
        if (!popularContainer) return;

        const addButton = popularContainer.querySelector(".dvb_popular-variants__button");
        if (addButton) {
          addButton.addEventListener("click", () => {
            this.addAllPopularVariants();
          });
        }
      }

      addAllPopularVariants() {
        const popularContainer = this.querySelector(".dvb_popular-variants");
        if (!popularContainer) return;

        const addButton = popularContainer.querySelector(".dvb_popular-variants__button");
        if (!addButton || addButton.disabled) return;

        const allItems = popularContainer.querySelectorAll(".dvb_popular-variants__item");
        allItems.forEach((item) => this.addVariantById(item.dataset.variantId));

        // Désactiver le bouton et changer le texte
        addButton.disabled = true;
        addButton.classList.add("dvb_popular-variants__button--added");
        addButton.textContent = addButton.dataset.textAdded || "Ajoutés";

        this.updateEverything();
      }

      addVariantById(variantId) {
        if (!variantId) return;
        const input = this.querySelector(`.deployer-quantity input[data-variant-id="${variantId}"]`);
        if (input && parseInt(input.value) < parseInt(input.max)) {
          input.stepUp();
        }
      }

      storeOriginalPrice() {
        const productInfoWrapper = this.closest(".product__info-wrapper");
        if (!productInfoWrapper) return;
        const priceContainer = productInfoWrapper.querySelector(".price__container");
        if (priceContainer) {
          this.originalPriceHtml = priceContainer.closest(".price").innerHTML;
        }
      }

      validateQtyAvailability(variant) {
        const input = variant.querySelector(".deployer-quantity input");
        const value = parseInt(input.value);
        if (value > parseInt(input.max)) {
          input.value = parseInt(input.max);
          variant.querySelector('.deployer-quantity button[name="plus"]').disabled = true;
        }
      }

      onInputQuantityChange(variant) {
        this.validateQtyAvailability(variant);
        this.updateEverything();
      }

      onButtonQuantityClick(element_clicked, variant) {
        const input = variant.querySelector(".deployer-quantity input");
        variant.querySelectorAll(".deployer-quantity button").forEach((button) => (button.disabled = false));
        if (element_clicked.name === "plus") {
          if (parseInt(input.value) < parseInt(input.max) || parseInt(input.max) == 0) input.stepUp();
          if (parseInt(input.value) == parseInt(input.max)) element_clicked.disabled = true;
          variant.classList.add('selected');
        } else {
          if (parseInt(input.value) > parseInt(input.min)) input.stepDown();
          if (parseInt(input.value) == 0) variant.classList.remove('selected');
        }
        this.updateEverything();
      }

      updateEverything() {
        this.addSelectionToForm();
        this.updateJauge();
        this.updateJaugeMessage();
        this.updatePriceJauge();
        this.updateDiscountMessage();
        this.updateResume();
        this.updateAddToCartState();
        // Fonctionne uniquement sur Dawn 👇🏻
        this.updateMainPrices();
      }

      updateDiscountMessage() {
        const messageContainer = this.querySelector(".dvb_discount-message");
        if (!messageContainer) return;

        const selectedCount = this.getNumberOfSelectedVariants();
        let message = "";

        if (typeof auto_discounts !== "undefined" && auto_discounts.length > 0) {
          for (const discount of auto_discounts) {
            if (selectedCount >= discount.threshold && discount.message) {
              message = discount.message;
            }
          }
        }

        messageContainer.textContent = message;
        messageContainer.style.display = message ? "block" : "none";
      }

      updatePriceJauge() {
        const priceJauge = this.querySelector(".dvb_price-jauge");
        if (!priceJauge) return;

        let remainingQuantity = this.getNumberOfSelectedVariants();

        priceJauge.querySelectorAll(".dvb_price-jauge__step").forEach((step) => {
          const progress = step.querySelector("progress");
          const badge = step.querySelector(".dvb_price-jauge__badge");
          
          badge.classList.remove("dvb_price-jauge__badge--active");
          
          if (remainingQuantity > 0) {
            const maxQuantity = parseInt(progress.dataset.max);
            if (remainingQuantity >= maxQuantity) {
              progress.value = 100;
              remainingQuantity -= maxQuantity;
              badge.classList.add("dvb_price-jauge__badge--active");
            } else {
              progress.value = 100 * (remainingQuantity / maxQuantity);
              remainingQuantity = 0;
            }
          } else {
            progress.value = 0;
          }
        });
      }

      resetMainFormInputs() {
        if (this.main_product_form.querySelector('[name="id"]')) this.main_product_form.querySelector('[name="id"]').remove();
        if (this.main_product_form.querySelector('[name="quantity"]')) this.main_product_form.querySelector('[name="quantity"]').remove();
        document.querySelectorAll(".from-variant-builder").forEach((input) => input.remove());
      }

      addSelectionToForm() {
        this.resetMainFormInputs();
        var index = 0;
        const sellingPlanId = this.getSyncedSellingPlanId();
        this.querySelectorAll(".deployer-quantity input").forEach((input) => {
          if (input != null && input.value > 0) {
            let fields = `<input type="hidden" class="from-variant-builder" name="items[${index}][id]" value="${input.dataset.variantId}"><input type="hidden" class="from-variant-builder" name="items[${index}][quantity]" value="${input.value}">`;
            if (sellingPlanId) {
              fields += `<input type="hidden" class="from-variant-builder" name="items[${index}][selling_plan]" value="${sellingPlanId}">`;
            }
            this.main_product_form.insertAdjacentHTML("beforeend", fields);
            index++;
          }
        });
      }

      updateJauge() {
        var reste = this.getNumberOfSelectedVariants();
        const progressContainer = this.querySelector(".dvb_progress-container");
        let allComplete = true;
        
        this.querySelectorAll(".dvb_progress-group").forEach((progressGroup) => {
          const progress = progressGroup.querySelector("progress");
          progressGroup.querySelectorAll(".dvb_progress-title").forEach((title) => title.classList.remove("dvb_progress-title--active"));
          if (reste > 0) {
            if (reste >= progress.dataset.max) {
              progress.value = 100;
              reste -= progress.dataset.max;
              progressGroup.querySelectorAll(".dvb_progress-title").forEach((title) => title.classList.add("dvb_progress-title--active"));
            } else {
              progress.value = 100 * (reste / progress.dataset.max);
              reste = 0;
              allComplete = false;
            }
          } else {
            progress.value = 0;
            allComplete = false;
          }
        });

        if (progressContainer) {
          if (allComplete && this.getNumberOfSelectedVariants() > 0) {
            progressContainer.classList.add("dvb_progress-container--complete");
          } else {
            progressContainer.classList.remove("dvb_progress-container--complete");
          }
        }
      }

      updateJaugeMessage() {
        const messageContainer = this.querySelector(".dvb_jauge-message");
        if (!messageContainer) return;

        const selectedCount = this.getNumberOfSelectedVariants();
        let message = "";
        let currentPalierIndex = -1;

        for (let i = 0; i < paliers_reduction.length; i++) {
          if (selectedCount >= paliers_reduction[i].quantity) {
            currentPalierIndex = i;
          }
        }

        const lastPalierIndex = paliers_reduction.length - 1;
        const isLastPalierReached = currentPalierIndex >= 0 && currentPalierIndex === lastPalierIndex;

        if (isLastPalierReached) {
          message = messageContainer.dataset.messageFinal || "";
        } else {
          const nextPalierIndex = currentPalierIndex + 1;
          if (nextPalierIndex < paliers_reduction.length) {
            message = messageContainer.dataset[`messagePalier${nextPalierIndex + 1}`] || "";
          }
        }

        messageContainer.textContent = message;
        messageContainer.style.display = message ? "block" : "none";
      }

      updateMainPrices() {
        const productInfoWrapper = this.closest(".product__info-wrapper");
        if (!productInfoWrapper) return;

        const priceElement = productInfoWrapper.querySelector(".price");
        if (!priceElement) return;

        const selectedCount = this.getNumberOfSelectedVariants();

        if (selectedCount === 0 || selectedCount === 1) {
          if (this.originalPriceHtml) {
            priceElement.innerHTML = this.originalPriceHtml;
          }
          return;
        }

        const totalPrice = this.getSelectionTotalPrice();
        const discountedPrice = this.getSelectionTotalDiscountedPrice();
        const total = formatPrice(totalPrice);
        const discountedTotal = formatPrice(discountedPrice);

        productInfoWrapper.querySelectorAll(".price__container").forEach((priceContainer) => {
          const regularPriceElement = priceContainer.querySelector(".price__regular .price-item--regular");
          const salePriceRegularElement = priceContainer.querySelector(".price__sale .price-item--regular");
          const salePriceSaleElement = priceContainer.querySelector(".price__sale .price-item--sale");

          if (totalPrice !== discountedPrice) {
            priceContainer.closest(".price").classList.add("price--on-sale");
            if (salePriceRegularElement) salePriceRegularElement.innerHTML = total;
            if (salePriceSaleElement) salePriceSaleElement.innerHTML = discountedTotal;
          } else {
            priceContainer.closest(".price").classList.remove("price--on-sale");
            if (regularPriceElement) regularPriceElement.innerHTML = total;
          }
        });
      }

      updateResume() {
        // Nombre d'unités
        if (this.querySelector(".dvb_resume-nombre-unite") != null) {
          const unitLabel = this.querySelector(".dvb_resume-nombre-unite #unitLabel");
          const unitQuantity = this.querySelector(".dvb_resume-nombre-unite #unitQuantity");
          unitQuantity.innerHTML = this.getNumberOfSelectedVariants();
          if (this.getNumberOfSelectedVariants() > 1) {
            unitLabel.innerHTML = unitLabel.dataset.labelPluriel;
          } else {
            unitLabel.innerHTML = unitLabel.dataset.labelSingulier;
          }
        }

        // Nombre de sous-unités
        if (this.querySelector(".dvb_resume-nombre-sous-unite") != null) {
          const sousUnitLabel = this.querySelector(".dvb_resume-nombre-sous-unite #sousUnitLabel");
          const sousUnitQuantity = this.querySelector(".dvb_resume-nombre-sous-unite #sousUnitQuantity");
          const totalSousUnit = this.getNumberOfSelectedVariants() * parseInt(sousUnitLabel.dataset.unitFactor);
          sousUnitQuantity.innerHTML = totalSousUnit;
          if (totalSousUnit > 1) {
            sousUnitLabel.innerHTML = sousUnitLabel.dataset.labelPluriel;
          } else {
            sousUnitLabel.innerHTML = sousUnitLabel.dataset.labelSingulier;
          }
        }

        // Prix par unité
        if (this.querySelector(".dvb_resume-unite-price") != null) {
          const priceByUnit = this.querySelector(".dvb_resume-unite-price #priceByUnit");
          if (this.getNumberOfSelectedVariants() === 0) {
            priceByUnit.innerHTML = "";
          } else {
            priceByUnit.innerHTML = formatPrice(this.getPriceByUnit()) + " " + priceByUnit.dataset.label;
          }
        }
      }

      updateAddToCartState() {
        const mainAtcButton = this.main_product_form.querySelector('button[type="submit"]');
        if (this.getNumberOfSelectedVariants() === 0) {
          mainAtcButton.setAttribute("disabled", "disabled");
        } else {
          mainAtcButton.removeAttribute("disabled");
        }
      }

      getNumberOfSelectedVariants() {
        var totalSelectedVariants = 0;
        this.querySelectorAll(".deployer-quantity input").forEach((input) => {
          totalSelectedVariants += parseInt(input.value);
        });
        return totalSelectedVariants;
      }

      getSelectionTotalPrice() {
        var total = 0;
        this.querySelectorAll(".dvb_variant").forEach((variant) => {
          if (variant.querySelector(".deployer-quantity input") != null) {
            const comparePrice = parseInt(variant.dataset.variantComparePrice);
            const quantity = parseInt(variant.querySelector(".deployer-quantity input").value);
            total += comparePrice * quantity;
          }
        });
        return total;
      }

      getSelectionTotalDiscountedPrice() {
        const selectedCount = this.getNumberOfSelectedVariants();
        let total = 0;

        // Si les réductions par quantité sont désactivées, calcul simple
        if (typeof enable_quantity_discount === "undefined" || enable_quantity_discount === false) {
          this.querySelectorAll(".dvb_variant").forEach((variant) => {
            if (variant.querySelector(".deployer-quantity input") != null) {
              const price = parseInt(variant.dataset.variantPrice);
              const quantity = parseInt(variant.querySelector(".deployer-quantity input").value);
              total += price * quantity;
            }
          });
        } else {
          // Calcul avec réductions par palier
          let currentPosition = 1;
          this.querySelectorAll(".dvb_variant").forEach((variant) => {
            if (variant.querySelector(".deployer-quantity input") != null) {
              const salePrice = parseInt(variant.dataset.variantPrice);
              const quantity = parseInt(variant.querySelector(".deployer-quantity input").value);
              
              for (let i = 0; i < quantity; i++) {
                let unitDiscount = 0;
                
                for (const palier of paliers_reduction) {
                  if (currentPosition % palier.quantity === 0) {
                    unitDiscount = palier.discount;
                  }
                }
                
                const unitPrice = salePrice - (salePrice * unitDiscount / 100);
                total += unitPrice;
                currentPosition++;
              }
            }
          });
        }

        // Appliquer la réduction automatique (palier le plus élevé atteint)
        if (typeof auto_discounts !== "undefined" && auto_discounts.length > 0) {
          let applicableDiscount = null;
          
          for (const discount of auto_discounts) {
            if (selectedCount >= discount.threshold) {
              applicableDiscount = discount;
            }
          }
          
          if (applicableDiscount && applicableDiscount.amount > 0) {
            total -= applicableDiscount.amount * 100; // Convertir € en centimes
          }
        }
        
        return Math.round(Math.max(0, total));
      }

      getPriceByUnit() {
        return this.getSelectionTotalDiscountedPrice() / this.getNumberOfSelectedVariants();
      }
    }
  );
}
